import { render, staticRenderFns } from "./producer_submit_stepper.vue?vue&type=template&id=0da52ec4"
import script from "./producer_submit_stepper.vue?vue&type=script&lang=js"
export * from "./producer_submit_stepper.vue?vue&type=script&lang=js"
import style0 from "./producer_submit_stepper.vue?vue&type=style&index=0&id=0da52ec4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports